var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useState } from 'react';
import t from 'prop-types';
import { is_touch_device } from './../util';
var ON_PRESIONADO = is_touch_device() ? 'onTouchStart' : 'onClick';

function BotonConBarraSecundaria(props) {
  var _eventHandlers;

  var _useState = useState(false),
      alternadorArregloBugFirefox = _useState[0],
      setAlternadorArregloBugFirefox = _useState[1];

  var herramientaId = props.herramientaId,
      grupo = props.grupo,
      seleccionado = props.seleccionado,
      onPresionado = props.onPresionado;

  function handlePresionado(e) {
    e.preventDefault();
    e.stopPropagation();

    if (seleccionado) {
      onPresionado('Puntero', grupo, true);
      return;
    }

    onPresionado(herramientaId, grupo, true);
  }

  function handleDesplegada(e) {
    // fix firefox: sirve para obligar a redibujar las barras de herremientas
    //    una vez terminada la animación.        
    if (e.propertyName === 'transform') {
      setAlternadorArregloBugFirefox(!alternadorArregloBugFirefox);
    }
  }

  var id = 'herramienta' + herramientaId;
  var extraClases = ['botonHerramienta', seleccionado ? 'activado' : '', seleccionado ? 'abierta' : ''];
  var eventHandlers = (_eventHandlers = {}, _eventHandlers[ON_PRESIONADO] = handlePresionado, _eventHandlers);
  var children = React.Children.map(props.children, function (child) {
    return child ? React.cloneElement(child, {
      onDesplegada: handleDesplegada
    }) : child;
  });
  return React.createElement('div', _extends({
    id: id,
    grupo: grupo,
    className: extraClases.join(' ')
  }, eventHandlers), React.createElement('div', {
    className: 'barraSecundaria' + (alternadorArregloBugFirefox ? ' arregloBugFirefox' : '')
  }, children));
}

BotonConBarraSecundaria.propTypes = process.env.NODE_ENV !== "production" ? {
  herramientaId: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton */
  grupo: t.string.isRequired,

  /** Indica si el boton esta presionado o no */
  seleccionado: t.bool.isRequired,
  onPresionado: t.func.isRequired,
  children: t.any
} : {};
export default BotonConBarraSecundaria;